import React, { useState, useEffect, useContext } from "react";

//package import

import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Pagination,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Chip,
  Modal,
  Paper,
  Stack,
  Tooltip,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

// User Imports
import { RoutesUrls, provinceRoutes } from "../../../Services/Routes/APP";
import { useNavigate } from "react-router-dom";
import { headersPost } from "../../../Services/API";
import { POU_API_ULRS } from "../../../Services/Routes/API";
import { getPagination } from "../../../common/functions";
import { province_Context } from "../../../context";
import { DetailsIcon, Users } from "../../../Svg";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";

//constants

const headings = [
  "Name",
  "District",
  "Population",
  "Population Served",
  "Action",
];
const usersHeading = ["Name", "Email", " Status"];

//component

const Pou = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  // States

  // const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(1);
  const [provinces, setProvinces] = useState([]);
  const [filteredProvinces, setFilteredProvinces] = useState([]);
  const [searched, setSearched] = useState("");
  // const [product, setProduct] = useState(null);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [api, setApi] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [usersModalOpen, setUsersModalOpen] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [searchData, setSearchData] = useState("");

  // constant

  const detailsHandler = (row) => {
    navigate(RoutesUrls.provinceAdmin + provinceRoutes.pouDetails, {
      state: {
        node: row,
      },
    });
  };

  // Get POU

  const getProvinces = () => {
    const data = {
      page: page,
    };
    setOpen(true);

    headersPost(POU_API_ULRS.GET_ALL_POU, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setProvinces(res?.data?.hospitals);
          setFilteredProvinces(res?.data?.hospitals);
          setTotalCount(res?.data?.total_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  //life cycle

  useEffect(() => {
    getProvinces();
  }, [api]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(true);
  };

  // Search Filter
  const requestSearch = (searchedVal) => {
    const filteredRows = provinces.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setFilteredProvinces(filteredRows);
  };

  const usersHandler = (users) => {
    setUsersModalOpen(true);
    setUsersList(users);
  };
  const usersHandlerClose = () => {
    setUsersModalOpen(false);
    setUsersList([]);
  };
  // render

  return (
    <Box>
      {/* <AppBar title={"Clinics"} /> */}
      {/* <Typography
        variant="h5"
        fontWeight={"bold"}
        component={"span"}
        sx={{
          paddingBottom: 2,

          textTransform: "uppercase",
        }}
      >
        {user?.name}
      </Typography>
      <Typography color={"text.grayText"}>Point of Use</Typography> */}

      <Box marginTop={2} mr={2} display={"flex"} justifyContent={"flex-end"}>
        <TextField
          size="small"
          type="search"
          placeholder="Search by name"
          value={searched}
          onChange={(e) => {
            setSearched(e.target.value);
            requestSearch(e.target.value);
          }}
          InputProps={{
            startAdornment: (
              <SearchIcon
                sx={{
                  color: theme.palette.primary.dark,
                }}
              />
            ),
          }}
          sx={{
            borderRadius: 25,
            backgroundColor: theme.palette.secondary.dark,
            [`.${outlinedInputClasses.root}`]: {
              borderRadius: 25,
              paddingX: 2,
            },
          }}
        ></TextField>
      </Box>
      <Box mt={2}>
        <Paper elevation={1}>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headings?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      <Chip
                        label={h}
                        sx={{
                          backgroundColor:
                            index === headings.length - 1
                              ? `${theme.palette.error.light}`
                              : `${theme.palette.secondary.dark}`,
                          borderRadius: 2,
                          color:
                            index === headings.length - 1
                              ? `${theme.palette.error.main}`
                              : `${theme.palette.primary.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredProvinces.length > 0 ? (
                  filteredProvinces?.map((row, index) => (
                    <TableRow key={`${index}-row.name-${index + 2}`}>
                      <TableCell align="center"   sx={{ wordWrap: "break-word"}}>{row?.name}</TableCell>
                      <TableCell align="center">{row?.district}</TableCell>

                      <TableCell align="center">{row?.population}</TableCell>
                      <TableCell align="center">
                        {row?.vaccinated || 0}
                      </TableCell>

                      <TableCell align="center">
                        <Stack
                          direction="row"
                          spacing={1}
                          justifyContent={"center"}
                        >
                          <Tooltip title="Details">
                            <Button
                              color="secondary"
                              variant="contained"
                              size="small"
                              onClick={() => detailsHandler(row)}
                              sx={{
                                borderRadius: 1,
                                minWidth: 2,
                                paddingX: 1,
                              }}
                            >
                              <DetailsIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Users">
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() => usersHandler(row?.users)}
                              sx={{
                                borderRadius: 1,

                                minWidth: 2,

                                paddingX: 1,
                              }}
                            >
                              <Users />
                            </Button>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    {" "}
                    <TableCell colSpan={5}>
                      {" "}
                      <Typography
                        variant="body1"
                        width={"100%"}
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        No Data Found
                      </Typography>{" "}
                    </TableCell>{" "}
                  </TableRow>
                )}
              </TableBody>
            </Table>

            <Box paddingTop={4} display={"flex"} justifyContent={"center"}>
              <Pagination
                count={totalCount > 10 ? getPagination(totalCount) : 1}
                page={page}
                onChange={handleChangePage}
                color="primary"
              />
            </Box>
          </TableContainer>
        </Paper>
        <Modal
          open={usersModalOpen}
          onClose={usersHandlerClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              minWidth: "50%",
              maxWidth: "90%",
              maxHeight: "80%",
              minHeight: "70%",
              boxShadow: 24,
              borderRadius: 3,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    {usersHeading?.map((h, index) => (
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                        }}
                        align="center"
                        key={`${index}-table-heading-${h}`}
                      >
                        <Chip
                          label={h}
                          sx={{
                            backgroundColor:
                              index === headings.length - 1
                                ? `${theme.palette.error.light}`
                                : `${theme.palette.secondary.dark}`,
                            borderRadius: 2,
                            color:
                              index === headings.length - 1
                                ? `${theme.palette.error.main}`
                                : `${theme.palette.primary.main}`,
                          }}
                        ></Chip>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {usersList?.map((row, index) => (
                    <TableRow key={`${index}-row.name-${index + 2}`}>
                      <TableCell
                        align="center"
                        sx={{
                          wordWrap: "break-word"
                        }}
                      >
                        {row?.name}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          maxWidth: { xs: "80px", sm: "140px", md: "300" },
                          wordWrap: "break-word",
                        }}
                      >
                        {row?.email}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={row?.is_active ? "Not verified" : "Verified"}
                          sx={{
                            backgroundColor: row?.is_active
                              ? `${theme.palette.error.light}`
                              : `${theme.palette.success.light}`,

                            borderRadius: 2,
                            color: row?.is_active
                              ? `${theme.palette.error.main}`
                              : `${theme.palette.success.main}`,
                          }}
                        ></Chip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Modal>
        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            color: theme.palette.primary.main,
          }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Snackbar
          open={alertOpen}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleClose} severity={alertIcon}>
            {alertMsg}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default Pou;
